import React, { memo, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './styles.module.scss'
import { useTableCount } from './useTableCount.hook'
import ProgressBar from '../ProgressBar'

const TableCountPage: React.FC = () => {
  const history = useHistory()
  const { tableCount, formState, handleTableCountChange, handleSubmit, handleSkip } = useTableCount()
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    handleSubmit()
  }

  const handleNextClick = () => {
    if (tableCount.trim()) {
      handleSubmit()
    }
  }

  return (
    <>
      <ProgressBar />
      <div className={styles.tableCountPage}>
        <div className={styles.tableCountLeftSection}>
          <div className={styles.tableCountTextContainer}>
            <div className={styles.textContent}>
              <span className={styles.tableCountTitle}>How many tables will be at your reception?</span>
              <span className={styles.tableCountDescription}>
                If you’re not sure, you can assume about XX people per round table and XX per standard long table.
              </span>
            </div>
          </div>
        </div>

        <div className={styles.tableCountRightSection}>
          <form onSubmit={handleFormSubmit} className={styles.tableCountForm}>
            <div className={`${styles.tableCountInputContainer} ${formState.error ? styles.hasError : ''}`}>
              <input
                className={styles.tableCountInput}
                placeholder="Type your table count here"
                value={tableCount}
                onChange={handleTableCountChange}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault()
                    handleFormSubmit(e)
                  }
                }}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                aria-label="Table count"
                aria-invalid={formState.error ? 'true' : 'false'}
                aria-describedby={formState.error ? 'table-count-error' : undefined}
                ref={inputRef}
              />
              {formState.error && (
                <div id="table-count-error" className={styles.errorMessage} role="alert" aria-live="polite">
                  {formState.error}
                </div>
              )}
            </div>
          </form>
          <span className={styles.skipTextMobile}>
            Not sure?{' '}
            <a onClick={handleSkip} className={styles.skipLink}>
              Skip this question.
            </a>
          </span>
          <button
            className={`${styles.tableCountButtonMobile} ${tableCount.trim() ? styles.hasValue : ''}`}
            onClick={handleNextClick}
            disabled={!tableCount.trim() || formState.isSubmitting}
          >
            Next
          </button>
        </div>
      </div>

      <div className={styles.continueDesktopContainer}>
        <div className={styles.continueDesktopWrapper}>
          <span className={styles.skipText}>
            Not sure?{' '}
            <a onClick={handleSkip} className={styles.skipLink}>
              Skip this question.
            </a>
          </span>
          <button
            className={`${styles.continueButton} ${tableCount.trim() ? styles.hasValue : ''}`}
            onClick={handleNextClick}
            disabled={!tableCount.trim() || formState.isSubmitting}
          >
            Next
          </button>
        </div>
      </div>
    </>
  )
}

TableCountPage.displayName = 'TableCountPage'

export default memo(TableCountPage)
